import { useEffect, useState } from "react"
import { get, post } from '@util/xhrAPI'
import Div from '@ui/layout/Div'
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from 'react-router'
import TextType from "@ui/inputs/TextType"
import Buttons from '@ui/elements/Buttons'
import { ROLE_PUBLIC } from '@router/Routes'
import { updateNotification } from '@store/slice/mainSlice'
import { useDispatch } from "react-redux"

const EmailValidation = () => {
  const dispatch = useDispatch()
  const { validationToken } = useParams()
  const [isValidToken, setValidToken] = useState(false)
  const [password, setPassword] = useState('')
  const [t] = useTranslation('user')
  const navigate = useNavigate()

  const validatePassword = () => {
    const dataForm = new FormData();
    dataForm.append('validationToken', validationToken)
    dataForm.append('password', password)
    post(`${import.meta.env.VITE_API_URL}/public/users/password-validation`, dataForm, response => {
      const { code } = response
      if (200 === code) {
        dispatch(updateNotification({ type: 'is-success', message: t('alerts.password_saved') }))
        setTimeout(() => {
          navigate(ROLE_PUBLIC['login'])
        }, 4000)
      }
    })
  }

  const renderPasswordZone = () => {
    return (
      <Div cssClass='password-creator'>
        <h2 className='scene-title'>{t('titles.create_password')}</h2>

        <TextType type='password' onChange={e => setPassword(e.target.value)} value={password} />
        <Buttons buttons={
          { icon: 'icon-floppy-disk', cssClass: 'is-info is-small', callback: () => validatePassword(), text: t('actions.save') }
        } />
      </Div>
    )
  }

  useEffect(() => {
    if (validationToken) {
      get(`${import.meta.env.VITE_API_URL}/public/users/email-validation/${validationToken}`, response => {
        const { code } = response
        if (code == 200) {
          setValidToken(true)
          dispatch(updateNotification({ type: 'is-success', message: t('alerts.verification_success') }))
        } else {
          setValidToken(false)
        }
      })
    }
  }, [validationToken])

  return (
    <>{isValidToken ? renderPasswordZone() : <></>}</>
  )
}

export default EmailValidation